import React from "react";

// Branded WhatsApp glyph (public domain simplified path)
function WhatsAppIcon({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M20.52 3.48A11.79 11.79 0 0 0 12.05 0C5.49 0 .18 5.31.18 11.87c0 2.09.55 4.13 1.6 5.93L0 24l6.35-1.66a11.85 11.85 0 0 0 5.7 1.45h.01c6.55 0 11.87-5.31 11.87-11.87 0-3.17-1.24-6.15-3.41-8.44Zm-8.47 18.28h-.01a9.85 9.85 0 0 1-5.02-1.38l-.36-.21-3.77.98 1.01-3.67-.24-.38a9.85 9.85 0 1 1 18.28-5.23c0 5.46-4.44 9.89-9.89 9.89Zm5.42-7.4c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.19.3-.77.96-.94 1.16-.17.19-.35.22-.65.07-.3-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.73-1.63-2.03-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.19-.3.29-.5.1-.19.05-.37-.02-.52-.07-.15-.67-1.62-.93-2.22-.24-.58-.49-.5-.67-.51h-.57c-.19 0-.5.07-.76.37-.26.3-1 1-1 2.44s1.03 2.83 1.17 3.03c.15.19 2.03 3.09 4.91 4.33.69.3 1.22.48 1.63.61.68.22 1.31.19 1.8.11.55-.08 1.75-.71 2-1.4.25-.69.25-1.28.17-1.4-.07-.13-.27-.19-.57-.34Z"/>
    </svg>
  );
}

/**
 * Floating WhatsApp Business chat button.
 * Genuine WhatsApp green (#25D366), white icon + text, rounded pill, premium shadow.
 * Number sourced from REACT_APP_WHATSAPP_NUMBER; hidden gracefully if missing.
 */
export default function WhatsAppFab({ message }) {
  const raw = process.env.REACT_APP_WHATSAPP_NUMBER || "";
  const number = raw.replace(/\D/g, "");
  if (!number) return null;

  const text = encodeURIComponent(
    message || "Hi OrangeBySite, I'm interested in finding out more about your services."
  );
  const href = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 inline-flex items-center gap-2.5 pl-3.5 pr-4 md:pr-5 rounded-full bg-[#25D366] text-white shadow-[0_12px_32px_-8px_rgba(37,211,102,0.55)] hover:shadow-[0_18px_44px_-8px_rgba(37,211,102,0.7)] hover:-translate-y-0.5 transition-all"
      style={{ height: "54px" }}
    >
      <span className="grid place-items-center text-white">
        <WhatsAppIcon size={22} />
      </span>
      <span className="hidden md:inline text-[12px] font-display font-bold tracking-[0.14em] uppercase">
        Chat with us
      </span>
    </a>
  );
}
